//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

export const MeetsGroupRequirement = {
    /**  Meets requirements */
    Meets: 0,

    /** Doesn't meet requirements */
    NotMet: 1,

    /** The meets with warning */
    MeetsWithWarning: 2,

    /** The Requirement doesn't apply for the GroupRole we are checking against */
    NotApplicable: 3,

    /** The Requirement calculation resulted in an exception GroupRequirementStatus.CalculationException */
    Error: 4
} as const;

export const MeetsGroupRequirementDescription: Record<number, string> = {
    0: "Meets",

    1: "Not Met",

    2: "Meets With Warning",

    3: "Not Applicable",

    4: "Error"
};

export type MeetsGroupRequirement = typeof MeetsGroupRequirement[keyof typeof MeetsGroupRequirement];
